import { computed, ref, type Ref } from 'vue';
import type { DinhMucCoDinhWizardStep } from '@/types/dinh-muc-co-dinh';
import {
  DINH_MUC_CO_DINH_WIZARD_STEP_DM_VAT_TU,
  DINH_MUC_CO_DINH_WIZARD_STEP_META,
  DINH_MUC_CO_DINH_WIZARD_STEPS,
} from '../constants';

export function useDinhMucCoDinhWizard(options?: {
  onBeforeLeaveMeta?: () => Promise<boolean> | boolean;
}) {
  const step = ref<DinhMucCoDinhWizardStep>(DINH_MUC_CO_DINH_WIZARD_STEP_META);

  const currentStepMeta = computed(
    () =>
      DINH_MUC_CO_DINH_WIZARD_STEPS.find((item) => item.id === step.value) ??
      DINH_MUC_CO_DINH_WIZARD_STEPS[0]
  );

  const isMetaStep = computed(
    () => step.value === DINH_MUC_CO_DINH_WIZARD_STEP_META
  );
  const isDmVatTuStep = computed(
    () => step.value === DINH_MUC_CO_DINH_WIZARD_STEP_DM_VAT_TU
  );

  const goToMeta = () => {
    step.value = DINH_MUC_CO_DINH_WIZARD_STEP_META;
  };

  const goToDmVatTu = async () => {
    if (options?.onBeforeLeaveMeta) {
      const ok = await options.onBeforeLeaveMeta();

      if (!ok) {
        return false;
      }
    }

    step.value = DINH_MUC_CO_DINH_WIZARD_STEP_DM_VAT_TU;

    return true;
  };

  const goBack = () => {
    if (isDmVatTuStep.value) {
      goToMeta();
    }
  };

  const resetWizard = () => {
    step.value = DINH_MUC_CO_DINH_WIZARD_STEP_META;
  };

  return {
    step: step as Ref<DinhMucCoDinhWizardStep>,
    steps: DINH_MUC_CO_DINH_WIZARD_STEPS,
    currentStepMeta,
    isMetaStep,
    isDmVatTuStep,
    goToMeta,
    goToDmVatTu,
    goBack,
    resetWizard,
  };
}
